import { render, staticRenderFns } from "./SavePassword.vue?vue&type=template&id=b5a8316a&scoped=true&"
import script from "./SavePassword.vue?vue&type=script&lang=js&"
export * from "./SavePassword.vue?vue&type=script&lang=js&"
import style0 from "./SavePassword.vue?vue&type=style&index=0&id=b5a8316a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a8316a",
  null
  
)

export default component.exports